<tam-dialog class="exchange-import-dialog" [opened]="isOpened" [dialogWidth]="dialogWidth">
    <ng-template #title>
        <span class="dialog-title">{{titleName}}</span>
        <smart-icon class="dialog-close dark" name="close" (click)="onCloseBtnClick($event)">
        </smart-icon>
    </ng-template>
    <ng-template #body>
        <div class="bodyContainer">
            <div class="use-record"> {{'exchange.import_contacts_with_same_properties' |
                stringLiterals}}</div>
            <div class="body-container body-1">
                <div *ngFor="let item of importData.contacts; trackBy:trackByFn" class="item-container">
                    <div class="information-container" *ngIf="item.duplicates&&item.duplicates.length>0">
                        <div class="exchange-contact-header">
                            <div class="contact-name">
                                <span class="exchange-title">{{'exchange.exchange_contact' |
                                    stringLiterals}}: </span>{{item.exchange.name}}
                                <span *ngIf="item.exchange.emailAddress">
                                    <{{item.exchange.emailAddress}}>
                                </span>
                            </div>
                            <div class="exchange-operator">
                                <label [ngClass]="{'create-label':item.isCreateNewContact}"
                                    (click)="onClickCreateNewContact(item)">{{'general.create_new' |
                                    stringLiterals}}</label>
                                <label *ngIf="item.isCreateNewContact" class="create-contact-undo"
                                    (click)="onClickUndo(item)">{{'general.undo' |
                                    stringLiterals}}</label>
                            </div>
                        </div>

                        <div class="item-duplicate-detail" *ngIf="!item.isCreateNewContact">
                            <div *ngFor="let duplicateItem of item.duplicates; trackBy:trackByFn">
                                <div class="item-duplicate-infor hover-item"
                                    [ngClass]="{'selected-item':duplicateItem.isSelected,'disable-item':duplicateItem.ownerID === currentUser.id}"
                                    (click)="onClickDuplicateContactItem(duplicateItem,item)">
                                    <div class="item-title body-3">{{duplicateItem.firstName}}
                                        {{duplicateItem.lastName}} </div>
                                    <div class="item-value body-1"><span class="caption">{{'exchange.job_title' |
                                            stringLiterals}}: </span><span
                                            [title]="getJobTitleByDuplicateItem(duplicateItem)">{{getJobTitleByDuplicateItem(duplicateItem)}}</span>
                                    </div>
                                    <div class="item-value body-1">
                                        <span class="caption">{{'general.company' |
                                            stringLiterals}}: </span>{{duplicateItem.webCompany.name}}
                                    </div>
                                    <div class="item-email">
                                        <div class="item-value body-1" *ngFor="let emailItem of duplicateItem.webEmail">
                                            <span class="caption">{{emailItem.name}}
                                                {{'general.email' |
                                                stringLiterals}}: </span>{{emailItem.address}}
                                        </div>
                                    </div>

                                    <label *ngIf="duplicateItem.ownerID" class="has-link-tip">*
                                        {{'exchange.this_contact_is_connected_by' |
                                        stringLiterals}}
                                        {{duplicateItem.ownerName}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template #footer>
        <button tam-button tamType="tertiary" tamSize="normal" class="dialog-button"
            (click)="onCancelBtnClick($event)">{{'general.back' | stringLiterals}}</button>
        <button tam-button tamType="primary" tamSize="normal" class="import-button"
            (click)="onClickImport($event)">{{'general.import' | stringLiterals}}</button>
    </ng-template>

</tam-dialog>